export default "__VITE_ASSET__8849449d__"